





































































































































































































































































































































































































































































import { Component, Ref, Vue, Watch} from 'vue-property-decorator'
import { CapaDaNotaParaCartaDeCorrecao, Fornecedor, Pageable } from '@/models';
import type { CapaDaNotaServiceAdapter } from '@/usecases';
import { Inject } from 'inversify-props'
import { Loja } from '@/models'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue';
import { obrigatorio } from '@/shareds/regras-de-form';
import { formatarDataHora } from '@/shareds/formatadores';
import { CartaDeCorrecao } from '@/models/fiscal/CartaDeCorrecao';
import { CartaDeCorrecaoUseCase, FindFornecedorUseCase, FindVendaUseCase } from '@/usecases';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import ComponentResourceGuard from '@/components/shareds/ComponentResourceGuard.vue';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import SeletorDeCfop from '@/components/fiscal/SeletorDeCfop.vue';
import ListagemDeCartasDeCorrecao from '../venda/ListagemDeCartasDeCorrecao.vue';

@Component({
	components: {
		SeletorDeLojas,
		ComponentResourceGuard,
		SeletorDeCfop,
		ListagemDeCartasDeCorrecao,
	},
})
export default class TelaDeCriacaoDeCartasDeCorrecao extends Vue {
	@Ref() listagemDeCartasDeCorrecao!: ListagemDeCartasDeCorrecao

	@Inject('CapaDaNotaServiceAdapter')
	private capaDaNotaService!: CapaDaNotaServiceAdapter

	private cartaDeCorrecaoUseCase = new CartaDeCorrecaoUseCase();
	findVendaUseCase = new FindVendaUseCase()
	findFornecedorUseCase = new FindFornecedorUseCase()
	
	obrigatorio = obrigatorio
	formatarDataHora = formatarDataHora
	
	numero = '';
	serie = '';
	loading = false;
	salvando = false;
	mostrarNota = false;
	loja: Loja | null = null
	notaFiscalParaCartaDeCorrecao: CapaDaNotaParaCartaDeCorrecao[] = []
	notaFiscalParaCartaDeCorrecaoOriginal: CapaDaNotaParaCartaDeCorrecao[] = []
	cartaDeCorrecao: CartaDeCorrecao | null = null
	loadingImpressao = false
	tipoDeFiltroSelecionado = 'nota'
	identificadorDaVenda = ''
	itemsEditados: Array<{
		codigoProduto: string
		nomeProduto: string
		cfop: string
		ncm: string
		cstIcms: number
		cstPis: number
		cstCofins: number
	}> = []
	listaDeFornecedores: Fornecedor[] = []
	busca: string | null = null
	buscandoFornecedores: boolean | null = null
	buscouTodasAsTransportadoras = false
	pageable: Pageable = {
		page: 0,
		size: 10,
	}

	headers = [
		{ text: 'Número', value: 'nnf' },
		{ text: 'Série', value: 'serie' },
		{ text: 'Data Emissão', value: 'dhEmi' },
		{ text: 'Valor', value: 'vnf' },
		{ text: 'Ações', value: 'acoes' },
	];

	get podeCriar(): boolean {
		return !!UserLoginStore.temAutorizacaoPorOperacaoERecurso('criar', 'criar-carta-correcao')
	}

	get podeEditar(): boolean {
		return !!UserLoginStore.temAutorizacaoPorOperacaoERecurso('alterar', 'criar-carta-correcao')
	}

	get apenasLeitura(): boolean {
		return !this.podeEditar && !!UserLoginStore.temAutorizacaoPorOperacaoERecurso('ler', 'criar-carta-correcao')
	}

	async buscarNotaFiscal() {
		if(!this.loja){
			AlertModule.setError('Necessário selecionar uma Loja');
			return
		}
		if((!this.numero || !this.serie) && this.tipoDeFiltroSelecionado === 'nota'){
			AlertModule.setError('Necessário digitar o Número da Nota e Serie');
			return
		}
		if(!this.identificadorDaVenda && this.tipoDeFiltroSelecionado === 'venda'){
			AlertModule.setError('Necessário um identificador de venda');
			return
		}

		try {
			this.loading = true;

			const params = {
				serie: this.tipoDeFiltroSelecionado === 'nota' ? this.serie : null,
				numero: this.tipoDeFiltroSelecionado === 'nota' ? this.numero : null,
				identificadorVenda: this.tipoDeFiltroSelecionado === 'venda' ? this.identificadorDaVenda : null,
			}

			this.notaFiscalParaCartaDeCorrecao = [
				await this.capaDaNotaService.findBySerieAndNnf(params, typeof this.loja === 'object' ? this.loja.id : this.loja),
			];

			this.notaFiscalParaCartaDeCorrecaoOriginal = JSON.parse(JSON.stringify(this.notaFiscalParaCartaDeCorrecao));

			this.cartaDeCorrecao = await (await this.cartaDeCorrecaoUseCase.findCartasDeCorrecao({
				chNFe: this.notaFiscalParaCartaDeCorrecaoOriginal[0].chNFe,
			})).content.slice(-1)[0];

			if (this.notaFiscalParaCartaDeCorrecao[0]?.itens) {
				this.itemsEditados = this.notaFiscalParaCartaDeCorrecao[0].itens.map(item => ({
					codigoProduto: item.codigoProduto,
					nomeProduto: item.nomeProduto,
					cfop: item.cfop,
					ncm: item.ncm,
					cstIcms: item.cstIcms,
					cstPis: item.cstPis,
					cstCofins: item.cstCofins,
				}));
			}

			this.buscarTransportadoras();
		} catch (error) {
			AlertModule.setError(error);
		} finally {
			this.loading = false;
		}
	}

	async salvarAlteracoes() {
		if (!this.notaFiscalParaCartaDeCorrecao[0] || !this.loja) return;

		try {
			this.salvando = true;

			const cartaDeCorrecao: CartaDeCorrecao = {
				id: '',
				chaveNFe: this.notaFiscalParaCartaDeCorrecaoOriginal[0].chNFe,
				lojaId: typeof this.loja === 'object' ? this.loja.id : this.loja,
				status: this.notaFiscalParaCartaDeCorrecao[0].cStat,
				sequencial: 0,
				descricaoDaCorrecao: 'Correção de informações dos itens da nota fiscal',
				motivoDeRetornoEvento: '',
				urlDoXml: '',
				enderecoDest: this.notaFiscalParaCartaDeCorrecao[0].lgrDest,
				nroDestAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].nroDest,
				nroDestCorrigido: this.notaFiscalParaCartaDeCorrecao[0].nroDest,
				complementoDestAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].xCplDest,
				complementoDestCorrigido: this.notaFiscalParaCartaDeCorrecao[0].xCplDest,
				razaoSocialDoDestAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].nomeDest,
				razaoSocialDoDestCorrigido: this.notaFiscalParaCartaDeCorrecao[0].nomeDest,
				enderecoEmit: this.notaFiscalParaCartaDeCorrecao[0].lgrEmit,
				nroEmitAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].nroEmit,
				nroEmitCorrigido: this.notaFiscalParaCartaDeCorrecao[0].nroEmit,
				complementoEmitAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].xCplEmit,
				complementoEmitCorrigido: this.notaFiscalParaCartaDeCorrecao[0].xCplEmit,
				razaoSocialDoEmitAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].nomeEmit,
				razaoSocialDoEmitCorrigido: this.notaFiscalParaCartaDeCorrecao[0].nomeEmit,
				informacoesAdicionaisAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].informacoesAdicionais,
				informacoesAdicionaisCorrigido: this.notaFiscalParaCartaDeCorrecao[0].informacoesAdicionais,
				volumeAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].volume,
				volumeCorrigido: this.notaFiscalParaCartaDeCorrecao[0].volume,
				especieAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].especie,
				especieCorrigido: this.notaFiscalParaCartaDeCorrecao[0].especie,
				pesoBrutoAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].pesoBruto,
				pesoBrutoCorrigido: this.notaFiscalParaCartaDeCorrecao[0].pesoBruto,
				pesoLiquidoAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].pesoLiquido,
				pesoLiquidoCorrigido: this.notaFiscalParaCartaDeCorrecao[0].pesoLiquido,
				possuiFrete: this.notaFiscalParaCartaDeCorrecao[0].possuiFrete,
				transportadoraAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].transportadora,
				transportadoraCorrigido: this.notaFiscalParaCartaDeCorrecao[0].transportadora,
				tipoDeFreteAtual: this.notaFiscalParaCartaDeCorrecaoOriginal[0].tipoDeFrete,
				tipoDeFreteCorrigido: this.notaFiscalParaCartaDeCorrecao[0].tipoDeFrete,
				itens: this.notaFiscalParaCartaDeCorrecao[0].itens.map((item, index) => ({
					codigoProduto: item.codigoProduto,
					cfopAtual: item.cfop,
					cfopCorrigido: this.itemsEditados[index].cfop,
					nomeProdutoAtual: item.nomeProduto,
					nomeProdutoCorrigido: this.itemsEditados[index].nomeProduto,
					ncmAtual: item.ncm,
					ncmCorrigido: this.itemsEditados[index].ncm,
					cstIcmsAtual: item.cstIcms,
					cstIcmsCorrigido: this.itemsEditados[index].cstIcms,
					cstPisAtual: item.cstPis,
					cstPisCorrigido: this.itemsEditados[index].cstPis,
					cstCofinsAtual: item.cstCofins,
					cstCofinsCorrigido: this.itemsEditados[index].cstCofins,
				})),
			};

			await this.cartaDeCorrecaoUseCase.criarCartaDeCorrecao(cartaDeCorrecao);
			AlertModule.setSuccess('Carta de correção criada com sucesso!');
			this.mostrarNota = false;

			this.cartaDeCorrecao = await (await this.cartaDeCorrecaoUseCase.findCartasDeCorrecao({
				chNFe: this.notaFiscalParaCartaDeCorrecaoOriginal[0].chNFe,
			})).content.slice(-1)[0];

		} catch (error) {
			AlertModule.setError(error);
		} finally {
			this.salvando = false;
		}
	}

	limparCampos() {
		this.notaFiscalParaCartaDeCorrecao = [];
		this.notaFiscalParaCartaDeCorrecaoOriginal = [];
		this.cartaDeCorrecao = null;
		this.itemsEditados = [];
		this.numero = '';
		this.serie = '';
		this.identificadorDaVenda = '';
	}

	apresentarNota(){
		this.mostrarNota = !this.mostrarNota
	}

	async imprimirCartaDeCorrecao(){
		this.loadingImpressao = true

		try{
			const filtro: any = {};

			if (this.identificadorDaVenda != null && this.identificadorDaVenda !== '') {
				filtro.identificador = this.identificadorDaVenda;
			} else {
				filtro.numeroNota = this.numero;
				filtro.serie = this.serie;
			}

			const vendaCompleta = await this.findVendaUseCase.find(filtro);
			this.listagemDeCartasDeCorrecao.mostrar(vendaCompleta.content[0]);
		}catch (e){
			AlertModule.setError("Erro ao imprimir carta de correção: " + e)
			this.loadingImpressao = false
		} finally{
			this.loadingImpressao = false
		}
	}

	@Watch('tipoDeFiltroSelecionado')
	limparFiltros(){
		this.serie = ''
		this.numero = ''
		this.identificadorDaVenda = ''
	}

	cancelar() {
		this.mostrarNota = false;
		this.loadingImpressao = false;
		this.buscarNotaFiscal();
	}

	async buscarTransportadoras() {
		try {
			this.buscandoFornecedores = true
			this.buscouTodasAsTransportadoras = false
			this.busca = null
			
			const params = {
				tipoFornecedor: 'Transportadora',
				page: this.pageable.page ? this.pageable.page : 0,
				size: this.pageable.size,
				sort: this.pageable.sort,
				busca: this.busca,
			}

			const fornecedoresPage = await this.findFornecedorUseCase.find(params)

			if (!fornecedoresPage.last) {
				this.pageable.page = !this.pageable.page
					? 1
					: (this.pageable.page += 1)
				this.listaDeFornecedores.push(...fornecedoresPage.content)
				this.buscouTodasAsTransportadoras = false
			} else {
				this.listaDeFornecedores.push(...fornecedoresPage.content)
				this.buscouTodasAsTransportadoras = true
			}
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.buscandoFornecedores = false
		}
	}
}
